// Verify2FA.js
import React, { useState } from 'react';
import axios from 'axios';
import { verify2fa } from '../../util/api';

import css from './Verify2FA.module.css';
import { FieldTextInput, PrimaryButton, FieldCodeInput } from '../../components';

export default function Verify2FA({ userId, onVerified }) {
  // const [token, setToken] = useState('');
  const [error, setError] = useState(null);

  const handleVerify = async token => {
    try {
      setError(null);
      const res = await verify2fa({ userId, token });
      if (res.ok) {
        onVerified();
      } else {
        setError('Invalid code');
      }
    } catch (err) {
      console.log('err', err);
      setError('Error verifying code');
    }
  };

  return (
    <div className={css.root}>
      {/* <FieldTextInput
        className={css.codeInput}
        name='code'
        type="text"
        placeholder="Enter 6-digit code"
        label="Enter the 6-digit code from your authenticator app"
        value={token}
        onChange={e => setToken(e.target.value)}
      /> */}
      <FieldCodeInput onComplete={handleVerify} />
      {/* <PrimaryButton onClick={handleVerify}>Verify</PrimaryButton> */}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
}
